export default {
  setLang (lang) {
     window.sessionStorage.setItem('user_lang', lang)
  },
  getLang (defaultLang) {
    const localLang = window.sessionStorage.getItem('user_lang')
    if (localLang === null) {
      return defaultLang
    } else {
      return localLang
      }
  }
}


// WEBPACK FOOTER //
// ./src/language/lang.js